var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5",staticStyle:{"min-height":"100%","min-width":"100%"}},[_c('Navigation'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }